import { Alert } from '@mui/material'
import React from 'react'

const AlertMessage = ({ text }) => {
  return (
    <Alert
      sx={{ color: 'black', borderColor: 'black', '.MuiAlert-icon': { color: 'black' } }}
      variant="outlined"
      severity="info"
    >
      {text}
    </Alert>
  )
}

export default AlertMessage
